// True when the app runs as an installed PWA (home-screen app) rather than in a
// normal browser tab. Chromium reports this via the `display-mode: standalone`
// media query; iOS Safari exposes the non-standard `navigator.standalone`.
export function isStandalone(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}
